import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { observer } from "mobx-react";
import moment from "moment";
import { useEffect } from "react";
import { TransactionsChart } from "./transactionsChart.js";
import { TransactionsSkeleton } from "./transactionsSkeleton.js";
import { TransactionsTable } from "./transactionsTable.js";
import { DateRangePicker } from "../../../../../../components/dateRangePicker.js";
import { useAvailableDateRangesForFilter } from "../../../../../../hooks/useAvailableDateRangesForFilter.js";
import { useStores } from "../../../../../../store/stores.js";
import { __ } from "../../../../../../utils/i18n.js";
import { EmptyState } from "../../../emptyState.js";
import { AffiliatePanel } from "../affiliatePanel.js";
const TransactionsPage = observer(()=>{
    const { accountV2Store: { session } } = useStores();
    const affiliate = session?.affiliate;
    const availableRanges = useAvailableDateRangesForFilter();
    useEffect(()=>{
        affiliate?.fetchTransactions();
    }, []);
    if (!affiliate) {
        return null;
    }
    const { isBusyTransactions, transactions, statistics, transactionFilters: { dates: currentDates } } = affiliate;
    const hasChart = statistics.length > 0 && statistics.some(({ value })=>!!value);
    const isEmpty = transactions.size === 0 && !isBusyTransactions;
    return /*#__PURE__*/ _jsx(AffiliatePanel, {
        heading: __("Transactions"),
        subline: __("Sales, clicks, and commissions for the selected period."),
        action: /*#__PURE__*/ _jsx(DateRangePicker, {
            disabledDate: (d)=>!d || d.isAfter(moment()),
            value: currentDates,
            ranges: availableRanges,
            onChange: (dates)=>{
                affiliate.applyTransactionDates(dates || [
                    undefined,
                    undefined
                ]);
                affiliate.fetchTransactions();
            }
        }),
        children: isBusyTransactions ? /*#__PURE__*/ _jsx(TransactionsSkeleton, {}) : isEmpty ? /*#__PURE__*/ _jsx(EmptyState, {
            heading: __("There are no transactions in the selected period")
        }) : /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                hasChart && /*#__PURE__*/ _jsx(TransactionsChart, {}),
                /*#__PURE__*/ _jsx("div", {
                    style: {
                        marginTop: 24
                    },
                    children: /*#__PURE__*/ _jsx(TransactionsTable, {})
                })
            ]
        })
    });
});
export { TransactionsPage };
